module.exports = __webpack_public_path__ + "img/elckerlijc.39accb95.jpg";